// @flow

// eslint doen't seem to understand this flow line
// eslint-disable-next-line
const fn = <T>(toTransform: T[]): T[] => {
  if (toTransform.length <= 1) {
    return [...toTransform];
  }

  const [head, ...tail] = toTransform;
  return [head, ...fn(tail.reverse())];
};

export default fn;
